import { selectUtil } from "../../Redux/features/utilsSlice";
import { useAppDispatch, useAppSelector } from "../../Redux/app/hooks";
import { filter } from "../../Pages/PrivatePages/util";
import {
  getStudentsFormDetails,
  resetStudentParams,
  selectStudents,
} from "../../Redux/features/studentsSlice";
import ReactSuiteDropdown from "../Form/Dropdowns/NewDropdown";
import { FilterContainer } from "../../Pages/PrivatePages/style";
import FilterButtons from "./FilterButtons";
import { FC } from "react";
import { resetAdmissions } from "../../Redux/features/admissionSlice";

interface FilterSectionProps {
  filterFunction?: any;
}

const InitiatedAdmissionsFilter: FC<FilterSectionProps> = ({
  filterFunction,
}) => {
  const { sessions } = useAppSelector(selectUtil);
  const { SessionId } = useAppSelector(selectStudents);

  const sessionFilter = filter(sessions, "sessionName", "sessionId");

  const dispatch = useAppDispatch();

  const handleSelect = (name: string, value: string | number) => {
    dispatch(getStudentsFormDetails({ name, value }));
  };

  return (
    <FilterContainer className="flex-centered-items">
      <ReactSuiteDropdown
        dropdownItems={sessionFilter}
        title={`Session`}
        handleDropdownSelect={handleSelect}
        name="SessionId"
        value={SessionId}
      />
      <FilterButtons
        filterFunction={filterFunction}
        resetFilterFunction={() => {
          dispatch(resetStudentParams());
          dispatch(resetAdmissions());
        }}
      />
    </FilterContainer>
  );
};

export default InitiatedAdmissionsFilter;
